import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)

// 引入ui组件
import naive from 'naive-ui'


// 引入请求api文件 挂载到win对象
import { request } from '@/assets/js/http.js';
import utils from '@/assets/js/utils';
import allapi from "@/assets/js/allapi";
window.$utils = utils;
window.$http = request;
window.$api = allapi;

// 挂载弹窗到win对象
import { createDiscreteApi } from 'naive-ui'
const { message, notification, dialog, loadingBar } = createDiscreteApi(
    ['message', 'dialog', 'notification', 'loadingBar']
)
window.$message = message;
window.$notification = notification;
window.$dialog = dialog;
window.$loadingBar = loadingBar;

// 引入elmentui组件
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
app.use(ElementPlus, { size: 'default', zIndex: 3000 ,locale: zhCn,})

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
import vueAsign  from 'vue-asign'

// 引入静态资源
import "@/assets/css/reset.css"
import "@/assets/css/public.css"

import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'
// import hasPermission from './assets/js/haspermission'
// .use(hasPermission)

app.use(router).use(vueAsign ).use(naive).use(ViewUIPlus).mount('#app')
